import { Check, Minus } from "lucide-react";
import React from "react";
import CheckboxBase, { ICheckboxBaseProps } from "../CheckboxBase";
import * as S from "./styled";

export type TCheckboxProps = Omit<
    ICheckboxBaseProps,
    "labelSize" | "labelColor" | "helperTextSize" | "type" | "renderIcon"
> & {
    indeterminate?: boolean;
};

const Checkbox: React.FC<TCheckboxProps> = ({ size = "sm", indeterminate = false, trackData, ...props }) => {
    return (
        <CheckboxBase
            type="checkbox"
            size={size}
            labelColor="text-primary-1200"
            labelSize={size === "sm" ? "label-small-medium" : "label-regular-medium"}
            helperTextSize={size === "sm" ? "label-small-regular" : "label-regular-regular"}
            renderIcon={checked => (
                <S.Checkbox>
                    {checked && !indeterminate && <Check />}
                    {checked && indeterminate && <Minus />}
                </S.Checkbox>
            )}
            trackData={{
                ...trackData,

                indeterminate
            }}
            {...props}
        />
    );
};

export default Checkbox;
